import { Page, Text, View } from '@react-pdf/renderer';
import React from 'react';
import { convertAmountToWords, formatCurrency, isEmpty } from '../../generalFunctions';
import Header from './common/Header';
import Signature from './common/Signature';
import { PDF_ALL_MARGIN, PDF_LEFT_MARGIN, PDF_RIGHT_MARGIN } from '../../constants';

const ReceiptPdf = (props) => {
    const getBillIds = (billsArray) => {
        if (!isEmpty(billsArray)) {
            const bills = billsArray;
            const billIds = bills.map((b) => b.id);
            return `for Bill Number(s) ${billIds.toString()}`;
        }
        else {
            return "";
        }
    }

    const getAmount = () => {
        const tds = !isEmpty(props.data.tds) ? Number(props.data.tds) : 0;
        const totalAmount = Number(props.data.amount) + tds;
        return totalAmount;
    }

    return (
        <Page style={{ paddingLeft: PDF_LEFT_MARGIN, margin: PDF_ALL_MARGIN, paddingRight: PDF_RIGHT_MARGIN }} id={props.data.id} size="A4">
            <View style={{ border: 2, padding: 5 }}>
                <Header title={"R  E  C  E  I  P  T"} date={props.data.receiptDate} id={props.data.id} hideGst={true} />

                <View style={{ flexDirection: "row", padding: 10, marginBottom: 3 }}>
                    <Text style={{
                        fontSize: 12,
                        flexDirection: "column",
                        marginRight: 20,
                        flexGrow: 1,
                        lineHeight: 1.5
                    }}>
                        {`Received from ${props.data.receiptFor} sum of Rs. ${convertAmountToWords(getAmount(props.data.amount))}only through ${props.data.receiptType} ${getBillIds(props.data.billIds)}. ${props.data.narration}`}
                    </Text>
                </View>

                <View style={{ flexDirection: "row", padding: 10 }}>
                    <Text style={{
                        fontSize: 13,
                        flexGrow: 0.3,
                        alignSelf: "flex-start",
                        border: 1,
                        padding: 5,
                        maxWidth: 100
                    }}>Rs. {formatCurrency(getAmount(props.data.amount))}</Text>
                </View>

                <Signature />
            </View>
        </Page>
    );
}

export default ReceiptPdf;